import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { ThumbsDown } from "@faire/web--source/slate/icons/foundation/ThumbsDown";
import { ThumbsUp } from "@faire/web--source/slate/icons/foundation/ThumbsUp";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled, { css } from "styled-components";

import { Feedback } from "./types";
import { trackCsatClick } from "./utils";

interface IProps {
  visibleWhen: boolean;
  value: Feedback | undefined;
  onChange: (value: Feedback) => void;
  brandOrRetailerToken: string | undefined;
  issue: string;
}

export const YesNoButtons: React.FC<IProps> = ({
  visibleWhen,
  value,
  onChange,
  brandOrRetailerToken,
  issue,
}) => {
  if (!visibleWhen) {
    return null;
  }

  const yesVariant = value === "Yes" ? "primary" : "secondary";
  const noVariant = value === "No" ? "primary" : "secondary";
  const handleClickOn = (isUseful: Feedback) => {
    trackCsatClick(brandOrRetailerToken, issue, isUseful);
    onChange(isUseful);
  };

  return (
    <WrapperColumn>
      <Row>
        <Typography variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Was this helpful?"
            description={{
              img: "https://cdn.faire.com/fastly/7fc8ec7069ecccad6240ffe14879565292493bb0145048fa5b80d2e8e84cba6b.png",
            }}
          />
        </Typography>
      </Row>
      <Row gap={10}>
        <StyledButton variant={yesVariant} onClick={() => handleClickOn("Yes")}>
          <ThumbsUp fontSize="16px" />
          <Typography>
            <StrictLocalMsg
              defaultMessage="Yes"
              description={{
                img: "https://cdn.faire.com/fastly/7fc8ec7069ecccad6240ffe14879565292493bb0145048fa5b80d2e8e84cba6b.png",
              }}
            />
          </Typography>
        </StyledButton>
        <StyledButton variant={noVariant} onClick={() => handleClickOn("No")}>
          <ThumbsDown fontSize="16px" />
          <Typography>
            <StrictLocalMsg
              defaultMessage="No"
              description={{
                img: "https://cdn.faire.com/fastly/7fc8ec7069ecccad6240ffe14879565292493bb0145048fa5b80d2e8e84cba6b.png",
              }}
            />
          </Typography>
        </StyledButton>
      </Row>
    </WrapperColumn>
  );
};

const WrapperColumn = styled(Column).attrs({ gap: "1x" })``;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getSpacing("1x")};
  padding: ${getSpacing("0", "3x")};
  height: ${getSpacing("5x")};

  ${(props) =>
    props.variant === "primary"
      ? css`
          * {
            color: ${Core.surface.inverse};
          }
        `
      : null};

  &:hover * {
    color: ${Core.surface.inverse};
  }
`;
